import useTranslation from 'next-translate/useTranslation';
import { twJoin } from 'tailwind-merge';
import tinycolor from 'tinycolor2';

type SimpleColorVariantsProps = {
    colorVariants: {
        value: string;
        parameterValueImages?: string[] | null;
    }[];
};

const SimpleColorVariants: FC<SimpleColorVariantsProps> = ({ colorVariants }) => {
    const { t } = useTranslation();

    if (colorVariants.length === 0) {
        return null;
    }

    return (
        <div className="-mr-1 mb-3 flex min-h-[15px] space-x-1 pt-2">
            {colorVariants.map(
                (variant, index) =>
                    index <= 4 && (
                        <div
                            key={variant.value}
                            className={twJoin(
                                'rounded flex h-4 w-4 items-center rounded-full',
                                tinycolor(variant.value).isLight() && 'border border-grayDark',
                            )}
                            style={
                                variant.parameterValueImages?.[0]
                                    ? {
                                          background: `transparent url(${variant.parameterValueImages[0]}) no-repeat center center`,
                                      }
                                    : { backgroundColor: variant.value }
                            }
                        />
                    ),
            )}
            {colorVariants.length > 5 && (
                <span className="!ml-2 text-tiny text-grayDark">
                    {t('and {{ count }} more', {
                        count: colorVariants.length - 5,
                    })}
                </span>
            )}
        </div>
    );
};

export default SimpleColorVariants;
